// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.conversation.SatelliteWebLandlordConversationHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ExportExcelLeadsForListingRequestDto,
  ExportExcelLeadsForUserRequestDto,
  ListingAlias,
  SatelliteWebLandlordAddSystemMessageRequestDto,
  SatelliteWebLandlordAddSystemMessageResponseDto,
  SatelliteWebLandlordArchiveConversationRequestDto,
  SatelliteWebLandlordConversationAddMessageRequestDto,
  SatelliteWebLandlordConversationAddMessageResponseDto,
  SatelliteWebLandlordConversationGetMessagesRequestDto,
  SatelliteWebLandlordConversationGetMessagesResponseDto,
  SatelliteWebLandlordConversationSearchRequestDto,
  SatelliteWebLandlordConversationSearchResponseDto,
  SatelliteWebLandlordGetAttachmentsMetadataRequestDto,
  SatelliteWebLandlordGetAttachmentsMetadataResponseDto,
  SatelliteWebLandlordGetCachedConversationCountsResponseDto,
  SatelliteWebLandlordGetConversationInformationByInquiryIdRequestDto,
  SatelliteWebLandlordGetConversationInformationByInquiryIdResponseDto,
  SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
  SatelliteWebLandlordGetLatestConversationsForInboxResponseDto,
  SatelliteWebLandlordGetLatestForContactsPageRequestDto,
  SatelliteWebLandlordGetLatestForContactsPageResponseDto,
  SatelliteWebLandlordMarkConversationAsReadRequestDto,
  SatelliteWebLandlordMarkConversationAsUnreadRequestDto,
  SatelliteWebLandlordReportConversationRequestDto,
  SatelliteWebLandlordUnarchiveConversationRequestDto,
  SatelliteWebLandlordUpdateConversationAttributesRequestDto,
  SatelliteWebLandlordUpdateTourScheduledTimeRequestDto,
} from '../..';

interface StreamPhoneRecordingParams {
  callGuid: string;
  listingAlias: ListingAlias;
}

export const SatelliteWebLandlordConversationHandler_addMessage_Path = '/api/web/landlord/v1/conversation/addMessage';

/**
 * Add a message to a conversation
 */
export const SatelliteWebLandlordConversationHandler_addMessage = (
  postData: SatelliteWebLandlordConversationAddMessageRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordConversationAddMessageRequestDto,
    SatelliteWebLandlordConversationAddMessageResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordConversationHandler_addMessage_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_addSystemMessage_Path =
  '/api/web/landlord/v1/conversation/addSystemMessage';

/**
 * Add a predefined system message to a conversation
 */
export const SatelliteWebLandlordConversationHandler_addSystemMessage = (
  postData: SatelliteWebLandlordAddSystemMessageRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordAddSystemMessageRequestDto,
    SatelliteWebLandlordAddSystemMessageResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordConversationHandler_addSystemMessage_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_archiveConversation_Path =
  '/api/web/landlord/v1/conversation/archiveConversation';

/**
 * Archive a conversation
 */
export const SatelliteWebLandlordConversationHandler_archiveConversation = (
  postData: SatelliteWebLandlordArchiveConversationRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordArchiveConversationRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_archiveConversation_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_Path =
  '/api/web/landlord/v1/conversation/exportExcelLeadsForListing';

/**
 * Export leads for a listing in Excel
 */
export const SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing = (
  postData: ExportExcelLeadsForListingRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ExportExcelLeadsForListingRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_exportExcelLeadsForListing_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_exportExcelLeadsForUser_Path =
  '/api/web/landlord/v1/conversation/exportExcelLeadsForUser';

/**
 * Export leads for all user listings in Excel
 */
export const SatelliteWebLandlordConversationHandler_exportExcelLeadsForUser = (
  postData: ExportExcelLeadsForUserRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ExportExcelLeadsForUserRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_exportExcelLeadsForUser_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_Path =
  '/api/web/landlord/v1/conversation/getAttachmentsMetadata';

/**
 * Get all attachments' metadata for a conversation
 */
export const SatelliteWebLandlordConversationHandler_getAttachmentsMetadata = (
  postData: SatelliteWebLandlordGetAttachmentsMetadataRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordGetAttachmentsMetadataRequestDto,
    SatelliteWebLandlordGetAttachmentsMetadataResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordConversationHandler_getAttachmentsMetadata_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_getCachedConversationCounts_Path =
  '/api/web/landlord/v1/conversation/getCachedConversationCounts';

/**
 * Get cached conversation counts from the last 90 days
 */
export const SatelliteWebLandlordConversationHandler_getCachedConversationCounts = (client = getClient()) => {
  return httpFrontEndRequest<never, never, SatelliteWebLandlordGetCachedConversationCountsResponseDto>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_getCachedConversationCounts_Path,
      method: 'GET',
      contextPath: '/satellite',
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_Path =
  '/api/web/landlord/v1/conversation/getConversationInformationByInquiryId';

/**
 * Get conversation information by inquiry Id
 */
export const SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId = (
  postData: SatelliteWebLandlordGetConversationInformationByInquiryIdRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordGetConversationInformationByInquiryIdRequestDto,
    SatelliteWebLandlordGetConversationInformationByInquiryIdResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordConversationHandler_getConversationInformationByInquiryId_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_Path =
  '/api/web/landlord/v1/conversation/getLatestConversationsForContactsPage';

/**
 * Get a landlord's most recently updated conversations for the Contacts Page only. Each conversation will include one message for that conversation. If the entire conversation consists of nothing but system messages, then the message included will be the most recent system message, otherwise the message included will be the most recent user message even if the most recent message is actually a system message. That is, system messages will only be returned if the entire conversation is composed solely of system messages.
 */
export const SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage = (
  postData: SatelliteWebLandlordGetLatestForContactsPageRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordGetLatestForContactsPageRequestDto,
    SatelliteWebLandlordGetLatestForContactsPageResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordConversationHandler_getLatestConversationsForContactsPage_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_Path =
  '/api/web/landlord/v1/conversation/getLatestConversationsForInbox';

/**
 * Get a landlord's most recently updated conversations for the Inbox page only. Each conversation will include one message for that conversation. If the entire conversation consists of nothing but system messages, then the message included will be the most recent system message, otherwise the message included will be the most recent user message even if the most recent message is actually a system message. That is, system messages will only be returned if the entire conversation is composed solely of system messages.
 */
export const SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox = (
  postData: SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
    SatelliteWebLandlordGetLatestConversationsForInboxResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordConversationHandler_getLatestConversationsForInbox_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_getMessages_Path = '/api/web/landlord/v1/conversation/getMessages';

/**
 * Get messages for a conversation
 */
export const SatelliteWebLandlordConversationHandler_getMessages = (
  postData: SatelliteWebLandlordConversationGetMessagesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordConversationGetMessagesRequestDto,
    SatelliteWebLandlordConversationGetMessagesResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordConversationHandler_getMessages_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_markConversationAsRead_Path =
  '/api/web/landlord/v1/conversation/markConversationAsRead';

/**
 * Mark a conversation as read
 */
export const SatelliteWebLandlordConversationHandler_markConversationAsRead = (
  postData: SatelliteWebLandlordMarkConversationAsReadRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordMarkConversationAsReadRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_markConversationAsRead_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_markConversationAsUnread_Path =
  '/api/web/landlord/v1/conversation/markConversationAsUnread';

/**
 * Mark a conversation as unread
 */
export const SatelliteWebLandlordConversationHandler_markConversationAsUnread = (
  postData: SatelliteWebLandlordMarkConversationAsUnreadRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordMarkConversationAsUnreadRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_markConversationAsUnread_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_reportConversation_Path =
  '/api/web/landlord/v1/conversation/reportConversation';

/**
 * Report a conversation. This will always mark the conversation as read by the reporting user, and depending on the reason provided, could also mark the conversation as spam.
 */
export const SatelliteWebLandlordConversationHandler_reportConversation = (
  postData: SatelliteWebLandlordReportConversationRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordReportConversationRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_reportConversation_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_search_Path = '/api/web/landlord/v1/conversation/search';

/**
 * Search conversations for partial or full matching renter names or renter phone numbers
 */
export const SatelliteWebLandlordConversationHandler_search = (
  postData: SatelliteWebLandlordConversationSearchRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordConversationSearchRequestDto,
    SatelliteWebLandlordConversationSearchResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordConversationHandler_search_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_streamPhoneRecording_Path =
  '/api/web/landlord/v1/conversation/streamPhoneRecording';

/**
 * Stream a phone recording
 */
export const SatelliteWebLandlordConversationHandler_streamPhoneRecording = (
  getParams: StreamPhoneRecordingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<StreamPhoneRecordingParams, never, void>(
    {
      getParams: getParams,
      endpoint: SatelliteWebLandlordConversationHandler_streamPhoneRecording_Path,
      method: 'GET',
      contextPath: '/satellite',
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_unarchiveConversation_Path =
  '/api/web/landlord/v1/conversation/unarchiveConversation';

/**
 * Unarchive a conversation
 */
export const SatelliteWebLandlordConversationHandler_unarchiveConversation = (
  postData: SatelliteWebLandlordUnarchiveConversationRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordUnarchiveConversationRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_unarchiveConversation_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_updateConversationAttributes_Path =
  '/api/web/landlord/v1/conversation/updateConversationAttributes';

/**
 * Update conversation attributes
 */
export const SatelliteWebLandlordConversationHandler_updateConversationAttributes = (
  postData: SatelliteWebLandlordUpdateConversationAttributesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordUpdateConversationAttributesRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_updateConversationAttributes_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordConversationHandler_updateTourScheduledTime_Path =
  '/api/web/landlord/v1/conversation/updateTourScheduledTime';

/**
 * Update the note for this conversation's scheduled tour time. This is only viewable by the landlord and is provided solely for her convenience: it is not an end-to-end touring solution. This tour schedule is the original satellite tour scheduling unrelated to ZRM Tours.
 */
export const SatelliteWebLandlordConversationHandler_updateTourScheduledTime = (
  postData: SatelliteWebLandlordUpdateTourScheduledTimeRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebLandlordUpdateTourScheduledTimeRequestDto, void>(
    {
      endpoint: SatelliteWebLandlordConversationHandler_updateTourScheduledTime_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
